import {remCalc} from '_themeUtils'
import type {ThemeBreakpoints} from '_uiComponents'

const sidebar = {
    Sidebar: {
        baseStyle: ({headerSize}: {headerSize: ThemeBreakpoints}) => ({
            sidebar: {
                w: {base: 'full', md: remCalc(400), lg: 'unset'},
                position: 'fixed',
                zIndex: 1,
                h: {base: `calc(100dvh - ${headerSize.base}px)`, sm: `calc(100dvh - ${headerSize.sm}px)`, md: `calc(100dvh - ${headerSize.md}px)`},
                top: {base: `${headerSize.base}px`, sm: `${headerSize.sm}px`, md: `${headerSize.md}px`},
                maxH: 'full',
                overflowY: 'auto',
                bg: 'color.background.header.default',
            },
        }),
    },
}

export default sidebar
